module.exports = __webpack_public_path__ + "static/plantify1-750392e7d4d9a8f53220d1c4bfaa4961.jpg";